const esTranslation = {
  Auth: {
    NoPermission: 'Usted no está autorizado para acceder a esta aplicación. Contacte al Administrador.',
    AdminDirectLoginBlocked: 'Por favor, inicie sesión en su cuenta en',
  },
  backgroundUpload: {
    maxLimit: 'Se ha alcanzado el límite máximo de cargas manuales. Espere un momento e intente nuevamente.',
  },
  basicInformation: {
    dateOfBirth: 'Fecha de Nacimiento',
    duplicateWorkerModal: {
      addNewWorker: 'Agregar nuevo trabajador',
      badgeNumber: 'Número de Insignia',
      dateOfBirth: 'Fecha de Nacimiento',
      primaryEmail: 'Correo Electrónico Principal',
      primaryPhone: 'Número de Teléfono Principal',
      proceedWithSelected: 'Continuar con el trabajador seleccionado',
      secondaryEmail: 'Correo Electrónico Secundario',
      secondaryPhone: 'Número de Teléfono Secundario',
      title: 'Perfiles coincidentes',
    },
    email: 'Correo electrónico',
    errors: {
      atLeastOneMandatory: 'Se requiere al menos un campo más: Correo Electrónico, Número de Celular o Fecha de Nacimiento.',
      emailRequired: 'Se requiere el Correo Electrónico',
      firstNameRequired: 'Se requiere el Nombre',
      invalidDate: 'Sírvase ingresar una fecha válida',
      invalidEmail: 'Sírvase ingresar un Correo Electrónico válido',
      invalidPhoneNumber: 'Sírvase ingresar un Número de Celular válido',
      lastNameRequired: 'Se requiere el Apellido',
      phoneNumberRequired: 'Se requiere el Número de Celular',
    },
    firstName: 'Nombre',
    lastName: 'Apellido',
    phoneNumber: 'Número de Celular',
    subtitle: 'Ingrese su información básica ',
    title: 'Registro del Trabajador',
    unverifiedWorkerWarning: 'Usted deberá registrarse como trabajador no verificado en el sitio de trabajo.',
  },
  biometricConsent: {
    acceptText:
      'Al marcar la siguiente casilla, otorgo mi consentimiento por escrito para que FCA recopile, capture, almacene, transmita, mantenga, procese, derive y utilice mi información biométrica personal, según lo descrito anteriormente.',
    consentText:
      'Mi información podrá ser recopilada, capturada, obtenida, almacenada y utilizada por Field Control Analytics ("FCA") para fines de identificación (en conjunto, "los Usuarios de Datos"). FCA podrá recopilar, capturar, obtener, almacenar, transmitir, mantener, procesar, derivar y utilizar mi información biométrica para ser utilizada en relación con los Servicios o para fines de identificación y acreditación. Esta información incluye información personal e información biométrica, como fotografías digitales. Se podrá utilizar reconocimiento facial, es decir, la comparación virtual de mis imágenes faciales, al iniciar sesión en la aplicación móvil de FCA, para permitir el acceso a la plataforma de capacitación en línea o para realizar un seguimiento de mi progreso a lo largo de la formación y registrar los resultados de mi evaluación. Mi información será conservada por FCA hasta que yo solicite por escrito que FCA la elimine. Podré ponerme en contacto con un representante de FCA para solicitar la eliminación de mi información de la base de datos de FCA. Al dar mi consentimiento para la recopilación y el uso de esta información, reconozco y acepto que FCA y sus representantes podrán utilizar y compartir mi información biométrica para los fines indicados anteriormente.',
    errors: {
      consentRequired: 'Sírvase aceptar el formulario de consentimiento de datos biométricos.',
      failedToAccept: 'No se pudo aceptar el formulario de consentimiento de datos biométricos.',
    },
    title: 'Consentimiento de Datos Biométricos',
  },
  registrationConsent: {
    termsCheckbox: 'He leído y acepto los Términos y Condiciones',
    authorizationCheckbox: 'He leído y acepto la Autorización de FCA relativa a la Acreditación y el Análisis',
    biometricCheckbox: 'He leído y acepto el Consentimiento de Datos Biométricos',
    applySignatureTitle: 'Apply Signature',
    applySignatureSubtext: 'Apply the signature you provided during account registration.',
  },
  registrationSignature: {
    title: 'Su Firma',
    subtitle: 'Firme una vez para confirmar los tres acuerdos',
    summary: {
      heading: 'Al firmar a continuación, confirma que ha leído y aceptado:',
      statement1:
        'Su firma se aplicará a los formularios de consentimiento de todos los proyectos a los que esté asignado, cubriendo los acuerdos anteriores.',
      statement2:
        'Puede actualizar su firma en cualquier momento desde la configuración de su perfil. Cualquier firma actualizada se aplicará a futuras asignaciones de proyectos.',
      statement3:
        'En algunos proyectos será asignado primero y deberá aceptar antes de que se emita una credencial. En otros será activado automáticamente, pero siempre conservará la opción de rechazar el proyecto.',
      statement4:
        'Algunos proyectos pueden requerir información adicional de su parte. Se le pedirá que la proporcione individualmente para cada proyecto.',
    },
    canvasPlaceholder: 'Dibuje su firma aquí',
    disclaimer:
      'Al firmar este documento con una firma electrónica, acepto que dicha firma será tan válida como las firmas manuscritas en la medida en que lo permita la ley local.',
    clear: 'Borrar Firma',
    back: 'Atrás',
    next: 'Siguiente',
  },
  capturePhoto: {
    buttons: {
      proceed: 'Continuar',
      retake: 'Volver a tomar',
    },
    convertingText: 'Convirtiendo la imagen…',
    errorReasons: 'Esto pudo haber ocurrido por las siguientes razones:',
    errors: {
      allFilesRejectedMixed:
        '{{invalidTypeCount}} tipo de archivo no válido y {{oversizedCount}} el archivo superó el límite de tamaño de 5 MB.',
      conversionFailed: 'No se puede convertir la imagen a formato jpeg.',
      fileSizeExceeded: 'La imagen seleccionada supera el límite de tamaño de 5 MB. Elija una imagen más pequeña.',
      invalidFileType: 'Tipo de archivo no válido. Seleccione un archivo de imagen (JPEG, PNG o HEIC).',
      multipleFilesInvalidTypeOnly:
        '{{validCount}} imágenes seleccionadas. {{invalidTypeCount}} archivos de tipo no válido rechazados.',
      multipleFilesSelected:
        'Se han seleccionado {{validCount}} imágenes. {{rejectedCount}} imágenes superaban el límite de tamaño de 5 MB y no se han seleccionado.',
      multipleFilesWithInvalidTypes:
        'Se han seleccionado {{validCount}} imágenes. Se han rechazado {{invalidTypeCount}} archivos de tipo no válido y {{oversizedCount}} archivos que superaban los 5 MB.',
      noAccessToCamera: 'Sin acceso a la cámara',
      noWebcam: 'Su dispositivo no cuenta con una cámara web',
      photoUploadFailed: 'No se pudo cargar la foto',
      webcamDisabled: 'La cámara de su dispositivo se encuentra bloqueada',
      webcamOff: 'La cámara de su dispositivo se encuentra apagada',
    },
    title: 'Capture la foto',
    faceValidation: {
      faceCentered: 'Rostro Centrado',
      headStraight: 'Cabeza Recta',
      goodLighting: 'Buena Iluminación',
      clearNoBlur: 'Clara / Sin Desenfoque',
      eyesVisible: 'Ojos Visibles',
      faceClearlyVisible: 'Rostro Claramente Visible',
      singleFaceDetected: 'Un Solo Rostro Detectado',
      correctDistance: 'Distancia Correcta',
    },
  },
  certifications: {
    addModal: {
      certificationGroup: 'Seleccione el Grupo de Certificación',
      certificationId: 'ID de la Certificación',
      certificationIdPlaceholder: 'Ingresar el ID de la Certificación',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción',
      exempted: 'exento',
      certificationIdRequired: 'Se requiere el ID de la Certificación',
      descriptionRequired: 'Se requiere la Descripción',
      expirationDate: 'Fecha de Expiración',
      expirationDateRequired: 'Se requiere la Fecha de Expiración',
      issueDate: 'Fecha de Expedición',
      issueDateRequired: 'Se requiere la Fecha de Expedición',
      mediaRequired: 'Se requiere al menos una imagen',
      otherGroup: 'Otros',
      title: 'Agregue una Certificación',
      type: 'Tipo',
      typeRequired: 'Se requiere el Tipo',
    },
    addNewCertificate: 'Agregue una Nueva Certificación',
    certificationId: 'ID de la Certificación',
    deleteCertificateModal: {
      aboutToDelete: 'Usted está a punto de eliminar su',
      certification: 'Certificación',
      errors: {
        failedToDelete: 'No fue posible eliminar la Certificación',
      },
      mayAffectBadge: 'Esto podría afectar el estatus de su credencial',
      title: '¿Está seguro?',
    },
    description: 'Descripción',
    editModal: {
      title: 'Editar la Certificación',
    },
    errors: {
      failedToAdd: 'No fue posible agregar la certificación',
      failedToLoadData: 'No fue posible agregar la información de la certificación',
      failedToLoadDetails: 'No fue posible cargar los detalles de la certificación',
      failedToSave: 'No fue posible guardar la certificación',
      failedToUpdate: 'No fue posible actualizar la certificación',
    },
    expirationDate: 'Fecha de Expiración',
    fcaEffectiveFrom: 'Vigente desde {{date}}',
    fcaGracePeriodPreactiveWorkerPeriodText:
      'Debe agregarse dentro de los {{gracePeriodInDays}} días posteriores a la activación de la credencial y antes de la fecha obligatoria {{date}}.',
    fcaGracePeriodText:
      'Debe agregarse dentro de los {{gracePeriodInDays}} días posteriores a la activación de la credencial.',
    issueDate: 'Fecha de Expedición',
    next: 'Siguiente: Formulario de Consentimiento',
    subtitle: 'Agregue una Certificación',
    title: 'Certificaciones',
    warning: {
      allThe: 'todos los/las',
      atLeastOneOfThe: 'al menos uno/una de los/las',
      cancel: 'Cancelar',
      certifications: 'Certificaciones',
      clickViewMore: 'Haga clic en Ver Más para obtener una lista de las certificaciones requeridas',
      consequenceText:
        'Si usted no agrega las certificaciones requeridas, no obtendrá la credencial hasta que las agregue. Usted podrá ingresar a su perfil y agegarlas luego si no puede hacerlo ahora.',
      pleaseAdd: 'Favor agregar',
      proceedAnyway: 'Proceder de todos modos',
      requiredCertifications: 'Certificaciones Requeridas',
      title: 'Advertencia de Certificación',
      viewMore: 'Ver Más',
    },
  },
  common: {
    addImage: 'Agregar una Imagen',
    addInput: 'Agregar $INPUT_VALUE',
    back: 'Atrás',
    cancel: 'Cancelar',
    clearAll: 'Borrar Todo',
    close: 'Cerrar',
    confirm: 'Confirmar',
    contactUs: 'Contáctenos',
    delete: 'Eliminar',
    done: 'Listo',
    download: 'Descargar',
    edit: 'Editar',
    fieldRequired: 'Se requiere {{field}}',
    help: 'Ayuda',
    loadingImages: 'Cargando imágenes…',
    more: 'más',
    myAccount: 'Mi Cuenta',
    next: 'Siguiente',
    offlineError: 'Su dispositivo está fuera de línea. Conéctese a internet e intente otra vez.',
    orSmall: 'o',
    otherValue: 'Otros  ({{value}})',
    privacyPolicy: 'Política de Privacidad',
    save: 'Guardar',
    selectAll: 'Seleccionar Todo',
    selectedValues: 'Valores Seleccionados',
    sessionExpired: 'Su sesión ha expirado. Vuelva a acceder.',
    update: 'Actualizar',
    verify: 'Verificar',
    warning: '¡Advertencia!',
    yes: 'Sí',
    saveChanges: 'Guardar Cambios',
    here: 'aquí',
    stableInternetRequired: 'Esta página necesita una conexión estable al internet para cargar y guardar los datos',
    images: 'Imágenes',
  },
  confirmResetPassword: {
    buttons: {
      backToSignIn: 'Regresar a Iniciar Sesión',
      continue: 'Continuar',
    },
    confirmPassword: 'Confirme su Contraseña',
    errors: {
      confirmPasswordMismatch: 'Las contraseñas no coinciden',
      confirmPasswordRequired: 'Se requiere confirmar la Contraseña',
      invalidPassword: 'Sírvase ingresar una contraseña válida',
      passwordRequired: 'Se requiere la Contraseña',
    },
    expiredLinkMessage: 'El vínculo ha expirado',
    password: 'Contraseña',
    subtitle: 'Ingrese su nueva Contraseña',
    successMessage: 'Su Contraseña se ha reinicializado exitosamente',
    title: 'Reinicie su Contraseña',
  },
  consentForm: {
    badgeSkippable: {
      goBack: 'Ir Atrás',
      provideNowOrLater: 'Usted puede proporcionar esta información ahora o posteriormente',
    },
    skippedFields: {
      back: 'Atrás',
      message:
        'Olvidó llenar {{fields}}. Sírvase volver atrás y proporcionar la información requerida antes de firmar el formulario de consentimiento.',
      title: 'Advertencia',
    },
    offlineSubmitSuccess: 'Consent forms saved. They will upload when you are back online.',
    registrationSuccess: '¡Felicitaciones, usted se ha registrado exitosamente!',
    step1: {
      next: 'Llene el Formulario de Consentimiento',
      projectAccepted: '¡Usted ha aceptado este proyecto!',
      projectAddress: 'Dirección del Proyecto',
      projectName: 'Nombre del Proyecto',
      title: 'Información del Proyecto',
    },
    step2: {
      completeRegistration: 'Complete Registration',
      customFields: 'Custom Fields',
      storedFields: 'Campos Almacenados',
      errors: {
        invalidPhoneNumber: 'Sírvase ingresar un Número de Celular válido',
        invalidSSN: 'Sírvase ingresar los 4 últimos dígitos de su número de seguro social',
      },
      sectionEntries: '{{count}} entries',
      sectionEntry: '{{count}} entry',
      standardFields: 'Standard Fields',
      subtitle: 'Ingrese su información de consentimiento',
      title: 'Formulario de Consentimiento',
    },
    step3: {
      sign: 'Firme el Formulario de Consentimiento',
    },
  },
  consentFormInformation: {
    customFields: 'Custom Fields',
    customFormChip: 'Personalizado',
    emergencyContactName: 'Nombre de Contacto',
    emergencyContactPhone: 'Teléfono de Contacto',
    projectInformation: 'Información del Proyecto',
    projectName: 'Nombre del Proyecto',
    selectEmployerError: 'Sírvase seleccionar a un empleado para revisar la información del formulario del proyecto',
    standardFields: 'Standard Fields',
    standardFormChip: 'Estándar',
    storedFields: 'Stored Fields',
    workerTrades: 'Oficios del Trabajador',
  },
  contactInformation: {
    contactInfo: {
      alternatePhone: 'Teléfono Alterno',
      email: 'Correo Electrónico',
      mobileNumber: 'Número de Celular',
      title: 'Información de Contacto',
    },
    emergencyContact: {
      mobileNumber: 'Número de Celular',
      modalMobileNumber: 'Número de Celular para Emergencias',
      modalName: 'Nombre de Contacto para Emergencias',
      modalRelationship: 'Relación con el Contacto para Emergencias',
      name: 'Nombre',
      relationship: 'Relación',
      title: 'Contacto para Emergencias',
    },
    errors: {
      addressLine1Required: 'Se requiere llenar la Línea 1 de la Dirección',
      addressLine2Required: 'Se requiere llenar la Línea 2 de la Dirección',
      alternatePhoneRequired: 'Se requiere un Teléfono Alterno',
      cityRequired: 'Se requiere la Ciudad',
      contactMethodRequired: 'Se requiere ya sea un Correo Electrónico o un Número de Teléfono',
      countryRequired: 'Se requiere el País',
      emailInvalid: 'Sírvase ingresar un correo electrónico válido',
      emailRequired: 'Se requiere el correo electrónico',
      emergencyContactNameRequired: 'Se requiere el Nombre del Contacto para Emergencias',
      emergencyContactNumberRequired: 'Se requiere el Número del Contacto para Emergencias',
      emergencyContactRelationshipRequired: 'Se requiere la Relación del Contacto para Emergencias',
      phoneInvalid: 'Sírvase ingresar un Número de Celular válido',
      phoneRequired: 'Se requiere un Número de Celular',
      stateRequired: 'Se requiere el Estado',
      zipCodeRequired: 'Se requiere el Código Postal',
    },
    homeAddress: {
      addressLine1: 'Línea 1 de la Dirección',
      addressLine2: 'Línea 2 de la Dirección',
      borough: 'Distrito de NYC',
      city: 'Ciudad',
      country: 'País',
      county: 'Condado',
      state: 'Estado',
      title: 'Dirección Domiciliaria',
      zipCode: 'Código Postal',
    },
    next: 'Siguiente: Industria',
    subtitle: 'Ingrese su información de contacto',
    title: 'Información de Contacto',
  },
  courses: {
    actions: {
      myCertifications: 'Mis Certificaciones',
      myProjects: 'Mis Proyectos',
      sort: 'Ordenar',
    },
    emptyState: {
      active: {
        subtitle: 'Usted no posee ningún curso activo',
        title: 'Sin Cursos Activos',
      },
      default: {
        subtitle: 'Al momento no hay cursos que mostrar',
        title: 'No hay cursos disponibles',
      },
      expired: {
        subtitle: 'Usted no posee ningún curso expirado',
        title: 'No hay cursos expirados',
      },
    },
    fields: {
      completionDate: 'Fecha de Finalización',
      exemptedFor: 'Exento para',
      expirationDate: 'Fecha de Expiración',
      requiredFor: 'Requerido por',
    },
    sort: {
      completionDateNewToOld: 'Ordenar por Finalización: De Antiguo a Nuevo',
      completionDateOldToNew: 'Ordenar por Finalización: De Nuevo a Aniguo',
      expirationDateNewToOld: 'Ordenar por Expiración: De Antiguo a Nuevo',
      expirationDateOldToNew: 'Ordenar por Expiración: De Nuevo a Aniguo',
      nameAtoZ: 'Ordenar por Nombre: De la A a la Z',
      nameZtoA: 'Ordenar por Nombre: De la Z a la A',
    },
    tabs: {
      active: 'Cursos Activos',
      expired: 'Cursos Expirados',
    },
    loadingNotice: 'Es posible que sus cursos tarden hasta 5 minutos en cargarse. Por favor, tenga paciencia.',
    title: 'Mis Cursos',
  },
  createPassword: {
    buttons: {
      createAccount: 'Crear Cuenta',
    },
    confirmPassword: 'Confirmar Contraseña',
    errors: {
      confirmPasswordMismatch: 'Ambas contraseñas deben coincidir',
      confirmPasswordRequired: 'Se requiere confirmar la Contraseña',
      invalidPassword: 'Ingrese una Contraseña válida',
      passwordRequired: 'Se requiere la Contraseña',
    },
    password: 'Contraseña',
    passwordMatcher: {
      rules: {
        length: 'Debe tener un mínimo de 8 a 15 caracteres',
        lowerCase: 'Incluir al menos una minúscula (a-z)',
        noSpaces: 'No debe tener espacios',
        notUsername: 'Su nombre de usuario y su contraseña no pueden ser iguales',
        number: 'Incluir al menos un número (0-9)',
        special: 'Incluir al menos un caracter especial (!, &,$)',
        title: 'La Contraseña debe:',
        upperCase: 'Incluir al menos una mayúscula (A-Z)',
      },
    },
    subtitle: 'Ingrese su contraseña',
    title: 'Crear Contraseña',
  },
  header: {
    adminMode: 'Modo Administrador',
    goToProjects: 'Ir a los Proyectos',
    logout: 'Cerrar sesión',
    loggingOut: 'Cerrando sesión',
    supervisorMode: 'Modo Supervisor',
    myProfile: 'Mi Perfil',
  },
  help: {
    description: 'Si presenta problemas con la funcionalidad en una tableta, puede comunicarse con nosotros',
    descriptionMobile: 'Si presenta problemas con la funcionalidad en una tableta, puede comunicarse con nosotros',
    phoneHours: '(de lunes a viernes, desde las 06:00 AM hasta las 06:00 PM. CST)',
    title: 'Ayuda',
  },
  login: {
    buttons: {
      login: 'Iniciar sesión',
    },
    email: 'Correo Electrónico',
    errors: {
      emailRequired: 'Se requiere el correo electrónico',
      invalidEmail: 'Sírvase ingresar un correo electrónico válido',
      invalidPassword: 'Sírvase ingresar una contraseña válida',
      invalidPhoneNumber: 'Sírvase ingresar un Número de Celular válido',
      passwordRequired: 'Se requiere la Contraseña',
      phoneNumberRequired: 'Se requiere el Número de Celular',
    },
    forgotPassword: '¿Olvidó su Contraseña?',
    loginTitle: 'Iniciar sesión',
    loginWithEmail: 'Iniciar sesión con Correo Electrónico',
    loginWithPhone: 'Iniciar sesión con Número Telefónico',
    multipleCompaniesTitle: 'Seleccione la Compañía',
    password: 'Contraseña',
    phoneNumber: 'Número de Celular',
    selectCompany: 'Seleccione la Compañía',
    subtitle: 'Ingrese su información de inicio de sesión',
    title: 'Inicio de sesión del Trabajador',
    companyAdminsWarning: 'Los administradores de la Compañía sólo pueden iniciar sesión',
  },
  myCertifications: {
    actions: {
      addCertification: 'Agregar Certificación',
      filter: 'Filtrar',
      myCourses: 'Mis Cursos',
      myProjects: 'Mis Proyectos',
      sort: 'Ordenar',
    },
    card: {
      addCertificate: 'Agregar Certificación',
      allMandatory: 'Todo obligatorio ',
      atLeastOneMandatory: 'Al menos uno es obligatorio',
      certificationId: 'ID de la Certificación',
      description: 'Descripción',
      expirationDate: 'Fecha de Expiración',
      issueDate: 'Fecha de Expedición',
      notMandatory: 'No es obligatorio',
      projectRequired: 'Requerido por el Proyecto',
      uploadNew: 'Cargar nuevo',
      viewDetails: 'Ver Detalles',
    },
    contextMenu: {
      delete: 'Eliminar',
      edit: 'Editar',
      viewDetails: 'Ver Detalles',
    },
    details: {
      certifications: 'certificaciones',
      optional: 'Opcional',
      pleaseAddAll: 'Sírvase agregar todos/todas los/las',
      pleaseAddAtLeastOne: 'Agregue al menos uno/a de los/las',
      title: 'Detalles de la Certificación',
    },
    emptyState: {
      current: {
        subtitle: 'Usted no tiene ninguna certificación vigente. Agregue sus certificaciones para comenzar.',
        title: 'No hay Certificaciones Vigentes',
      },
      default: {
        subtitle: 'No hay certificaciones para mostrar en este momento.',
        title: 'No hay Certificaciones Disponibles',
      },
      expired: {
        subtitle: 'Usted no tiene ninguna certificación expirada. ¡Mantenga al día sus certificaciones!',
        title: 'No hay Certificaciones Expiradas',
      },
      required: {
        subtitle: 'Usted no tiene ninguna certificación requerida en este momento.',
        title: 'No hay Certificaciones Requeridas',
      },
    },
    filter: {
      clearAll: 'Borrar todo',
      noRelatedProject: 'No hay Proyectos Relacionados',
      noResults: 'No se encontraron resultados',
      search: 'Buscar',
      selectAll: 'Seleccionar todo',
      title: 'Filtrar',
    },
    sort: {
      dateNewToOld: 'Ordenar por Fecha: De Nuevo a Antiguo',
      dateOldToNew: 'Ordenar por Fecha: De Antiguo a Nuevo',
      nameAtoZ: 'Ordenar por Nombre: De la A a la Z',
      nameZtoA: 'Ordenar por Nombre: De la Z a la A',
    },
    tabs: {
      current: 'Vigente',
      expired: 'Expirado',
      required: 'Requerido',
    },
    title: 'Mis Certificaciones',
  },
  myDrugTesting: {
    title: 'Pruebas de Drogas',
    tabs: {
      appointments: 'Ver Citas',
      thirdPartyResults: 'Ver Resultados de Pruebas de Terceros',
    },
    actions: {
      bookAppointment: 'Programar Cita',
      uploadResults: 'Cargar Resultados',
      viewMore: 'Ver Más',
      viewLess: 'Ver Menos',
    },
    uploadResults: {
      title: 'Cargar Resultados',
      editTitle: 'Editar Resultados',
      selectProject: 'Seleccione el Proyecto',
      enterTestDate: 'Ingrese la Fecha de la Prueba',
      facilityName: 'Nombre del Centro',
      panel: 'Panel',
      type: 'Tipo',
      reason: 'Razón',
      result: 'Resultado',
      selectPanelFirst: 'Sírvase seleccionar primero un panel',
      resultOptions: {
        negative: 'Negativo',
        batPass: 'BAT Aprobado',
      },
      confirm: 'Confirmar',
      successMessage: 'Los resultados se cargaron correctamente',
      updateSuccessMessage: 'Los resultados se actualizaron correctamente',
      upload: {
        hintPrefix: 'Toque aquí para',
        hint: 'Cargar Archivo',
        maxFiles: '(Puede cargar un máximo de {{count}} archivos)',
      },
      errors: {
        projectRequired: 'Se requiere el Proyecto',
        testDateRequired: 'Se requiere la Fecha de la Prueba',
        facilityNameRequired: 'Se requiere el Nombre del Centro',
        panelRequired: 'Se requiere el Panel',
        typeRequired: 'Se requiere el Tipo',
        reasonRequired: 'Se requiere la Razón',
        resultRequired: 'Se requiere el Resultado',
        filesRequired: 'Sírvase cargar al menos un archivo',
        fileTooLarge: 'Cada archivo debe ser de {{size}} MB o menos',
        invalidFileType: 'Solo se permiten archivos PDF, PNG, JPG y JPEG',
        filesUploadFailed: 'No se pudieron cargar {{count}} archivo(s). Vuelva a guardar para reintentar.',
      },
    },
    bookAppointment: {
      title: 'Programar Cita',
      editTitle: 'Editar Cita',
      selectProject: 'Seleccione el Proyecto',
      selectFacility: 'Seleccione el Centro de Pruebas',
      selectPanel: 'Seleccione el Panel de Pruebas',
      selectType: 'Seleccione el Tipo de Prueba',
      reason: 'Razón',
      selectDate: 'Seleccione la Fecha de la Cita',
      confirm: 'Confirmar',
      facilityInformation: 'Información del Centro',
      facilityAddress: 'Dirección del Centro',
      hoursOfOperation: 'Horario de Atención',
      successMessage: 'La cita se programó correctamente',
      updateSuccessMessage: 'La cita se actualizó correctamente',
      errors: {
        projectRequired: 'Se requiere el Proyecto',
        facilityRequired: 'Se requiere el Centro de Pruebas',
        panelRequired: 'Se requiere el Panel de Pruebas',
        typeRequired: 'Se requiere el Tipo de Prueba',
        reasonRequired: 'Se requiere la Razón',
        dateRequired: 'Se requiere la Fecha de la Cita',
      },
    },
    card: {
      address: 'Dirección',
      attachments: 'Archivos Adjuntos:',
      batResult: 'Resultado BAT',
      company: 'Compañía',
      details: 'Detalles',
      panel: 'Panel',
      project: 'Proyecto',
      reason: 'Razón',
      resultsStatus: 'Estado del Resultado',
      status: 'Estado',
      substance: 'Sustancia',
      testResult: 'Resultado de la Prueba',
      type: 'Tipo',
    },
    contextMenu: {
      delete: 'Eliminar Resultados',
      deleteAppointment: 'Eliminar',
      edit: 'Editar',
      editResults: 'Editar Resultados',
    },
    status: {
      pending: 'Pendiente',
      approved: 'Aprobado',
      denied: 'Denegado',
    },
    appointmentStatus: {
      scheduled: 'Programada',
      inProgress: 'En Progreso',
      missedAppointment: 'Cita Perdida',
      tested: 'Analizado',
      noShow: 'No se Presentó',
      pending: 'Pendiente',
      approved: 'Aprobado',
      denied: 'Denegado',
      unknown: 'Desconocido',
    },
    resultLabels: {
      notSet: 'No Establecido',
      negative: 'Negativo',
      nonConclusive: 'No Concluyente',
      invalid: 'Inválido',
      sentToLab: 'Enviado al Laboratorio',
      noShow: 'No se Presentó',
      cancelledByWorker: 'Cancelado por el Trabajador',
      batPass: 'BAT Aprobado',
      batFail: 'BAT Reprobado',
      positive: 'Positivo',
      lostInTransit: 'Perdido en Tránsito',
      leakDuringTransit: 'Fuga Durante el Tránsito',
      fatalFlaw: 'Falla Fatal',
      other: 'Otro',
    },
    invalidResultTypes: {
      insufficientSampleAmount: 'Cantidad de Muestra Insuficiente',
      refusalToProvideASample: 'Negativa a Proporcionar una Muestra',
      outOfTemperatureRange: 'Fuera del Rango de Temperatura',
      adulteratedSample: 'Muestra Adulterada',
    },
    deleteResultModal: {
      title: '¿Está seguro?',
      message: 'Usted está a punto de eliminar este resultado de prueba de drogas. Esta acción no se puede deshacer.',
      successMessage: 'El resultado de la prueba se eliminó correctamente',
      errors: {
        failedToDelete: 'No fue posible eliminar el resultado de la prueba de drogas.',
      },
    },
    deleteAppointmentModal: {
      title: '¿Está seguro?',
      message: '¿Está seguro de que desea eliminar esta cita?',
      successMessage: 'La cita se eliminó correctamente',
      errors: {
        failedToDelete: 'No fue posible eliminar la cita.',
      },
    },
    emptyState: {
      appointments: {
        title: 'No hay Citas',
        subtitle: 'Usted no tiene ninguna cita de prueba de drogas programada.',
      },
      thirdPartyResults: {
        title: 'No hay Resultados de Pruebas de Terceros',
        subtitle: 'Usted no tiene ningún resultado de prueba de drogas de terceros cargado.',
      },
    },
  },
  myProfile: {
    title: 'Mi Perfil',
    profilePicture: {
      menu: {
        capturePhoto: 'Capturar una Foto',
        uploadFromDevice: 'Subir desde el Dispositivo',
        seeGallery: 'Ver Galería',
      },
      gallery: {
        title: 'Galería de Imágenes',
        photo: 'Foto',
        current: 'Actual',
        loadError: 'Error al cargar la galería.',
        empty: 'No hay fotos disponibles.',
      },
    },
    tabs: {
      profileInformation: 'Información de Perfil',
      loginInformation: 'Información de Inicio de Sesión',
      changePassword: 'Cambiar Contraseña',
      createPassword: 'Crear Contraseña',
    },
    loginInformation: {
      email: {
        title: 'Direcciones de Correo',
        addButton: 'Agregar Correo',
        columnLabel: 'Dirección de Correo',
        placeholder: 'Ingrese nueva dirección de correo',
        empty: 'No se ha agregado un correo',
        note: 'Usted puede agregar varias direcciones de correo a su cuenta. El correo principal se usará para iniciar sesión y notificaciones importantes. Haga clic en "Convertir en Principal" para cambiar su correo de inicio de sesión, o "Eliminar" para borrar una dirección.',
      },
      mobile: {
        title: 'Números de celular',
        addButton: 'Agregar celular',
        columnLabel: 'Número de celular',
        placeholder: 'Ingrese número de celular',
        empty: 'No hay celular agregado',
        note: 'Puede agregar varios números de celular a su cuenta. El celular principal se usará para iniciar sesión y notificaciones importantes. Haga clic en "Hacer Principal" para cambiar su celular de inicio de sesión, o "Eliminar" para borrar un número.',
      },
      table: {
        statusColumn: 'Estado',
        actionsColumn: 'Acciones',
        primaryBadge: 'PRINCIPAL',
        secondaryBadge: 'SECUNDARIO',
        makePrimary: 'Hacer Principal',
        verify: 'Verificar',
        remove: 'Eliminar',
      },
      add: 'Agregar',
      errors: {
        emailRequired: 'La dirección de correo es obligatoria',
        invalidEmail: 'Por favor ingrese una dirección de correo válida',
        mobileRequired: 'El número de celular es obligatorio',
        invalidMobile: 'Por favor ingrese un número de celular válido',
      },
      toasts: {
        contactAdded: 'Contacto agregado exitosamente',
        primaryUpdated: 'Contacto principal actualizado exitosamente',
        contactRemoved: 'Contacto eliminado exitosamente',
      },
      enterPasswordModal: {
        title: 'Ingresar Contraseña',
        addDescriptionPrefix: 'Por favor ingrese su contraseña para agregar',
        addDescriptionSuffix: 'a su cuenta.',
        makePrimaryContactPrefix: 'Modificando',
        makePrimaryContactSuffix: 'al {{contactLabel}} principal.',
        makePrimaryInfo:
          'Esto habilitará este {{contactTypeLabel}} para el acceso a la cuenta. Usted podrá usar este {{contactTypeLabel}} como nombre de usuario al iniciar sesión.',
        makePrimaryWarning:
          'Cualquier {{contactTypeLabel}} principal anterior ya no será válido para el proceso de inicio de sesión.',
        verifyDescriptionPrefix: 'Enviaremos un enlace de verificación a',
        verifyDescriptionSuffix: 'Por favor ingrese su contraseña para continuar.',
        passwordPlaceholder: 'Ingrese contraseña actual',
        submit: 'Enviar',
        emailLabel: 'correo',
        phoneLabel: 'número de celular',
        emailTypeLabel: 'dirección de correo',
        phoneTypeLabel: 'número de celular',
      },
      removeModal: {
        emailTitle: 'Eliminar Dirección de Correo',
        mobileTitle: 'Eliminar Número de celular',
        heading: '¿Está seguro?',
        descriptionPrefix: '¿Está seguro de que desea eliminar',
        passwordPlaceholder: 'Ingrese contraseña actual',
      },
      verificationSentModal: {
        titlePart1: 'Se ha enviado un enlace de verificación',
        sentToEmail: 'a su correo electrónico',
        sentToPhone: 'a su teléfono',
        description: 'Por favor haga clic en ese enlace para verificar',
        verifyNow: 'Verificar Ahora',
      },
    },
    changePassword: {
      title: 'Cambiar Contraseña',
      oldPassword: 'Contraseña Anterior',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      buttons: {
        saveChanges: 'Guardar Cambios',
      },
      errors: {
        oldPasswordRequired: 'Se requiere la contraseña anterior.',
        newPasswordRequired: 'Se requiere una nueva contraseña.',
        confirmPasswordRequired: 'Se requiere confirmar la contraseña.',
        confirmPasswordMismatch: 'Ambas contraseñas deben coincidir.',
        invalidPassword: 'Por favor ingrese una contraseña válida.',
      },
      successMessages: {
        passwordChanged: 'Contraseña cambiada exitosamente',
      },
    },
    createPassword: {
      title: 'Crear Contraseña',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      buttons: {
        createPassword: 'Crear Contraseña',
      },
      errors: {
        newPasswordRequired: 'Se requiere una nueva contraseña.',
        confirmPasswordRequired: 'Se requiere confirmar la contraseña.',
        confirmPasswordMismatch: 'Ambas contraseñas deben coincidir.',
        invalidPassword: 'Por favor ingrese una contraseña válida.',
      },
      successMessages: {
        passwordCreated: 'Contraseña creada exitosamente',
      },
    },
    successMessages: {
      profileUpdated: 'Información de perfil actualizada con éxito',
    },
    signature: {
      sectionTitle: 'Firma',
      addSignature: 'Agregar Firma',
      editSignature: 'Editar Firma',
      save: 'Guardar Firma',
    },
  },
  personalInformation: {
    errors: {
      allergiesRequired: 'Especifique si tiene alguna alergia o seleccione "Ninguna".',
      dateOfBirthRequired: 'Se requiere la fecha de nacimiento',
      ethnicityRequired: 'Se requiere la etnia',
      firstNameMax: 'El nombre no puede exceder de 50 caracteres',
      firstNameMin: 'El nombre debe tener al menos 2 caracteres',
      firstNameRequired: 'Se requiere el nombre',
      genderRequired: 'Se requiere el género',
      idImageRequired: 'Se requiere la imagen de una identificación oficial',
      idNumberMax: 'El número de identificación no puede exceder de 20 caracteres',
      idNumberMin: 'El número de identificación debe tener al menos 4 caracteres',
      idNumberRequired: 'Se requiere el número de identificación',
      idTypeRequired: 'Se requiere el tipo de identificación',
      invalidSSN: 'Ingrese los últimos 4 dígitos de su número de seguro social',
      issuedByRequired: 'Autoridad emisora ​​obligatoria.',
      lastNameMax: 'El apellido no puede exceder de 50 caracteres',
      lastNameMin: 'El apellido debe tener al menos 2 caracteres',
      lastNameRequired: 'Se requiere el apellido',
      lastSSNRequired: 'Se requieren los últimos 4 dígitos de su número de seguro social',
      middleNameMax: 'El segundo nombre no puede exceder de 50 caracteres',
      middleNameRequired: 'Se requiere el segundo nombre',
      primaryLanguageRequired: 'Se requiere indicar su idioma principal',
      veteranStatusRequired: 'Se requiere indicar si tiene condición de veterano',
      profilePictureRequired: 'Se requiere una foto de perfil',
    },
    profilePhoto: 'Foto de Perfil',
    govtId: {
      idImage: 'Imagen de su identificación',
      idNumber: 'Número de identificación',
      idType: 'Tipo de identificación',
      issuedBy: 'Emitida por',
      title: 'Identificación oficial',
    },
    next: 'Siguiente: Información de Contacto',
    personalInformation: {
      allergies: 'Alergias',
      dateOfBirth: 'Fecha de Nacimiento',
      ethnicity: 'Etnia',
      firstName: 'Nombre',
      gender: 'Género',
      lastName: 'Apellido',
      lastSSN: 'Últimos 4 números del seguro social',
      middleName: 'Segundo nombre',
      primaryLanguage: 'Idioma Principal',
      title: 'Información Personal',
      veteran: 'Veterano',
      veteranStatus: 'Condición de Veterano',
    },
    skippable: {
      asterisk: '**',
      isRequiredButSkippableUntil: 'se requiere, pero se puede omitir hasta',
      provideNowOrLater: 'Usted puede proporcionar esta información ahora o posteriormente',
      requiredButSkippable: 'Se requiere, pero se puede omitir',
      skippableTill: {
        badgeActivation: 'Activación de la Credencial',
        badgePrinting: 'Impresión de la Credencial',
        consentForm: 'Formulario de Consentimiento',
        notSet: 'No configurado',
      },
    },
    subtitle: 'Ingrese su información personal',
    title: 'Información Personal',
  },
  piiPinVerificationModals: {
    enterPin: 'Ingrese el PIN enviado a',
    infoText:
      'Los datos de este campo son Información de Identificación Personal. Para editarlos, usted deberá confirmar su identidad proporcionando el PIN que le enviamos a su método de contacto principal.',
    receivePin: '¿Desea recibir un PIN?',
    resendPin: 'Reenviar PIN',
    title: 'Se requiere Información Adicional',
  },
  projectList: {
    actions: {
      addEmployer: 'Agregar Empleador',
      decline: 'Rechazar',
      myCertifications: 'Mis Certificaciones',
      myCourses: 'Mis cursos',
      register: 'Registrarse',
      sort: 'Ordenar',
      viewDocuments: 'Ver documentos',
      viewEBadge: 'Ver Credencial Electrónica',
      viewProfile: 'Ver Perfil',
    },
    declineConfirmationModal: {
      message: 'Usted está a punto de rechazar su proyecto de',
      title: '¿Está seguro?',
    },
    declineProject: 'Rechazar {{value}}',
    eBadgeModal: {
      noData: 'No hay datos de credencial disponibles',
      placeholder: 'Seleccione una compañía para ver la credencial electrónica.',
      selectCompany: 'Seleccionar Compañía',
      title: 'Credencial electrónica',
    },
    emptyState: {
      all: {
        subtitle: 'Usted aún no tiene proyectos. Una vez que se una o sea invitado proyectos, estos aparecerán aquí.',
        title: 'No se encontraron Proyectos',
      },
      current: {
        subtitle:
          'Usted no tiene ningún proyecto activo en este momento. Empiece a trabajar en un proyecto para verlo aquí.',
        title: 'No hay Proyectos Vigentes',
      },
      default: {
        subtitle: 'No hay proyectos para mostrar en este momento',
        title: 'No hay Proyectos Disponibles',
      },
      past: {
        subtitle: 'Usted aún no ha completado ningún proyecto. Sus proyectos finalizados se mostrarán aquí.',
        title: 'No hay Proyectos Previos',
      },
      pending: {
        subtitle:
          'Usted no tiene proyectos pendientes en este momento. Las invitaciones a nuevos proyectos aparecerán aquí.',
        title: 'No hay Proyectos Pendientes',
      },
      noProjects: 'No hay elementos disponibles',
    },
    errors: {
      registrationErrorBadgeRevoked: 'No se puede completar el registro; la credencial ha sido revocada',
    },
    selectCompanies: 'Seleccionar Compañías',
    sort: {
      dateNewToOld: 'Ordenar por fecha: de más reciente a más antiguo',
      dateOldToNew: 'Ordenar por fecha: de más antiguo a más reciente',
      nameAtoZ: 'Ordenar por nombre: de la A a la Z',
      nameZtoA: 'Ordenar por nombre: de la Z a la A',
    },
    status: {
      current: 'PROYECTO VIGENTE',
      past: 'PROYECTO ANTERIOR',
      pending: 'PROYECTO PENDIENTE',
    },
    tabs: {
      all: 'Todos los Proyectos',
      current: 'Proyectos Vigentes',
      past: 'Proyectos Anteriores',
      pending: 'Proyectos Pendientes',
    },
    title: 'Mis Proyectos',
    viewMissingRequirements: 'View missing requirements!',
    missingRequirementsModal: {
      title: 'Missing Requirements',
      itemRequired: '{{count}} item required',
      itemsRequired: '{{count}} items required',
      showDetails: 'Show Details',
      hideDetails: 'Hide Details',
      noteLabel: 'Note:',
      badge: {
        missing: 'MISSING',
      },
      certifications: {
        title: 'Missing / Expired Certifications',
        link: 'Go to My certifications',
      },
      courses: {
        title: 'Missing / Expired Courses',
        link: 'Go to My courses',
      },
      trainings: {
        title: 'Missing / Expired Trainings',
      },
      upcomingCertifications: {
        title: 'Upcoming Certifications Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      upcomingCourses: {
        title: 'Upcoming Courses Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      upcomingTrainings: {
        title: 'Upcoming Trainings Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      note: {
        gracePeriodPreactive: 'Must be added within {{days}} days from badge activation and before the mandatory date of {{date}}',
        effectiveFrom: 'Effective from {{date}}',
        gracePeriod: 'Must be added within {{days}} days from badge activation.',
      },
    },
  },
  resetPassword: {
    buttons: {
      backToLogin: 'Volver al Inicio de Sesión',
      backToSignIn: 'Volver a Iniciar Sesión',
      sendOneTimePassword: 'Enviar Contraseña de Un Solo Uso',
      sendResetLink: 'Enviar Vínculo de Reinicio',
    },
    email: 'Correo Electrónico',
    errors: {
      emailRequired: 'Se requiere un Correo Electrónico',
      invalidEmail: 'Ingrese un Correo Electrónico válido',
      invalidPhoneNumber: 'Ingrese un Número de Celular válido',
      phoneNumberRequired: 'Se requiere un Número de Celular',
    },
    or: 'o',
    phoneNumber: 'Número de Celular',
    subtitle: 'Ingrese su correo electrónico o número de celular registrado.',
    success: {
      title: 'Se ha enviado el vínculo  para Restablecer la Contraseña',
    },
    title: 'Restablezca su Contraseña',
  },
  selectProject: {
    buttons: {
      getStarted: 'Empezar',
    },
    employer: 'Empleador',
    errors: {
      employersRequired: 'Seleccione un empleador para continuar',
      failedToAssignWorkerToCompanies: 'No se pudo asignar al trabajador al proyecto ni a las compañías',
      positiveDrugTest:
        'Tiene una prueba de drogas positiva de {{projectName}} que le impide ser asignado a este proyecto.',
      positiveDrugTestWithValidity:
        'Tiene una prueba de drogas positiva de {{projectName}} que le impide ser asignado a este proyecto. Este resultado positivo será válido hasta el {{validUntil}}.',
      projectRequired: 'Seleccione un proyecto para continuar',
    },
    fca: 'Análisis de Control de Campo',
    project: 'Proyecto',
    selectEmployer: 'Seleccione el Empleador',
    selectProject: 'Seleccione el Proyecto',
    selectYourEmployer: 'Seleccione su empleador',
    selectYourProject: 'Seleccione su proyecto',
    employerStatus: {
      notAvailable: 'No Disponible',
      suspended: 'Suspendido',
    },
    warnings: {
      incompleteWorkers:
        'Hay algunos trabajadores incompletos en <bold>{{projectName}}</bold>. Complete o elimine todos los trabajadores antes de cambiar el proyecto.',
      loginRequired: 'Inicie sesión o utilice un código QR para acceder a la selección de proyectos',
      projectNotEnabled: 'Este proyecto no está disponible actualmente. Comuníquese con su supervisor.',
    },
    lockSelectedProject: 'Bloquear proyecto seleccionado',
    welcome: 'Bienvenido a',
  },
  signature: {
    clear: 'Borrar',
    description:
      'Al firmar este documento mediante firma electrónica, acepto que dicha firma será tan válida como una firma manuscrita, en la medida en que lo permitan las leyes locales',
    error: 'Sírvase proporcionar una firma',
    signNext: 'Enviar el Formulario de Consentimiento',
    title: 'Firma.',
  },
  takePhoto: {
    buttons: {
      capture: 'Capturar fotografía',
      skip: 'Omitir',
    },
    instructions: {
      0: {
        text: 'Use un fondo gris o neutro. Retírese la gorra, el casco de seguridad o cualquier otro PPE',
        title: 'Prepare su entorno',
      },
      1: {
        text: 'Retírese cualquier cubierta facial, incluyendo mascarillas y cualquier tipo de gafas: de medida, de seguridad y para el sol',
        title: 'Retírese las cubiertas faciales',
      },
    },
    subtitle: 'Capture su imagen',
    title: 'Tome una fotografía',
    warning: 'Recuerde que la mala calidad de una imagen puede retrasar su acceso a los sitios de trabajo',
  },
  trades: {
    addOtherTrade: 'Agregar otros oficios',
    errors: {
      laborUnionNumberMax: 'El número de sindicato no puede exceder de 20 caracteres',
      laborUnionNumberMin: 'El número de sindicato debe tener al menos 3 caracteres',
      laborUnionNumberRequired: 'Se requiere el número de sindicato',
      laborUnionRequired: 'Se requiere el sindicato',
      otherTradeMax: 'La descripción de otro oficio no puede exceder de 100 caracteres',
      roleRequired: 'Se requiere indicar el cargo',
      selectedTradesMinimum: 'Seleccione al menos un oficio',
      selectedTradesRequired: 'Se requiere seleccionar al menos un oficio',
      workExperienceRequired: 'Se requiere experiencia laboral',
    },
    laborUnion: 'Sindicato',
    laborUnionNumber: 'Número de sindicato',
    next: 'Siguiente: Certificaciones',
    otherTrade: 'Otro Oficio',
    role: 'Cargo',
    selectedTrades: 'Seleccionar Oficios',
    subtitle: 'Ingrese sus oficios',
    title: 'Oficios',
    workExperience: 'Experiencia Laboral',
  },
  verifyOtp: {
    buttons: {
      verifyAccount: 'Verificar Cuenta',
    },
    errors: {
      invalidOtp: 'La contraseña de un solo uso ingresada es incorrecta. Inténtelo de nuevo.',
      otpRequired: 'Ingrese su contraseña de un solo uso.',
    },
    subtitle: 'Ingrese la contraseña de un solo uso que fue enviada a <bold>{{destination}}</bold>',
    title: 'Ingrese su contraseña de un solo uso',
  },
  welcomeModal: {
    assignedTo: {
      part1: 'Usted está asignado a',
    },
    bullets: {
      certifications: {
        link: 'Mis Certificaciones',
        part1: 'Este proyecto requiere que usted cargue certificaciones específicas. Suba sus certificaciones a la',
        part2: 'página.',
      },
      courses: {
        link: 'Mis Cursos',
        part1: 'Este proyecto requiere que usted complete cursos específicos. Acceda a los cursos requeridos en la',
        part2: 'página.',
      },
      drugTesting: {
        link: 'aquí',
        part1:
          'Este proyecto requiere que los trabajadores se sometan a pruebas de detección de drogas. Programe las respectivas citas para las pruebas de detección de drogas requeridas.',
      },
      workerProfile: {
        link: 'Perfil del Trabajador',
        part1: 'Vaya a su',
        part2: 'para editar su información, ver sus tareas y acceder a sus credenciales.',
      },
    },
    description: 'Para completar su registro y activar su credencial:',
    loginLink: 'Acceda a',
    loginDescription:
      'su Perfil del Trabajador para editar su información, ver sus tareas y acceder a sus credenciales.',
    title: '¡Bienvenido a bordo!',
  },
  workerRegistration: {
    email: 'Correo electrónico',
    errors: {
      emailRequired: 'Se requiere un Correo Electrónico',
      invalidEmail: 'Ingrese un Correo Electrónico válido',
      invalidPhoneNumber: 'Ingrese un Número de Celular válido',
      phoneNumberRequired: 'Se requiere un Número de Celular',
    },
    phoneNumber: 'Número de Celular',
    unverifiedWorkerWarning:
      'Usted puede proporcionar su información de contacto ahora o registrarse como trabajador no verificado en el sitio de trabajo.',
    welcome: '¡Bienvenido!',
  },
  workerStatus: {
    actions: {
      deleteWorker: 'Eliminar Trabajador',
      editDetails: 'Editar Detalles',
      selectProject: 'Seleccionar Proyecto',
      uploadData: 'Subir Información',
      viewDetails: 'Ver Detalles',
    },
    card: {
      createdOn: 'Fecha de Creación',
      email: 'Correo Electrónico',
      lastUpdatedOn: 'Última Actualización',
      mobileNumber: 'Número de Celular',
      projectName: 'Nombre del Proyecto',
    },
    deleteWorkerModal: {
      message: '¿Está seguro de que desea eliminar?',
      title: '¿Está seguro?',
    },
    emptyState: {
      completed: {
        subtitle: 'Usted no tiene trabajadores completados.',
        title: 'No hay Trabajadores Completados',
      },
      default: {
        subtitle: 'No hay trabajadores para mostrar en este momento.',
        title: 'No hay Trabajadores Disponibles',
      },
      incomplete: {
        subtitle: 'Usted no tiene trabajadores incompletos.',
        title: 'No hay Trabajadores Incompletos',
      },
      pending: {
        subtitle: 'Usted no tiene trabajadores pendientes.',
        title: 'No hay Trabajadores Pendientes',
      },
      processing: {
        subtitle: 'Usted no tiene trabajadores en proceso.',
        title: 'No hay Trabajadores en Proceso',
      },
    },
    errors: {
      registrationNotCompleted: 'No se puede completar el registro',
    },
    profileWarningModal: {
      buttonText: 'Actualizar Ahora',
      pleaseComplete: 'Sírvase completar',
      pleaseUpload: 'Sírvase subir al trabajador',
      title: 'Actualización de Perfil Pendiente',
    },
    tabs: {
      completed: 'Completado',
      incomplete: 'Incompleto',
      pending: 'Pendiente',
      processing: 'En Proceso',
    },
    title: 'Estatus del Trabajador',
    warningMessage:
      'Los trabajadores completados se mostrarán durante 24 horas. Los trabajadores pendientes e incompletos se mostrarán durante 14 días.',
  },
  workerStatusLoginModal: {
    invalidPinError: 'PIN no válido',
    title: 'Introduzca el PIN',
  },
  PageNotFoundMessage: 'No se encontró ninguna página aquí.',
  UnAuthorizedMessage: 'Usted no está autorizado para acceder a esta página',
  Warning: 'Advertencia',
};

export default esTranslation;
